export enum TaskActivityType {
  TaskCreated = 'TaskCreated',
  TaskStatusChanged = 'TaskStatusChanged',
  TaskPriorityChanged = 'TaskPriorityChanged',
  TaskProgressChanged = 'TaskProgressChanged',
  TaskBudgetEstimationChanged = 'TaskBudgetEstimationChanged',
  TaskTimeEstimationChanged = 'TaskTimeEstimationChanged',
  TaskLocationChanged = 'TaskLocationChanged',
  TaskIndustryChanged = 'TaskIndustryChanged',
  TaskParticipantsAssigned = 'TaskParticipantsAssigned',
  TaskFileAdded = 'TaskFileAdded',
  TaskMessageAdded = 'TaskMessageAdded',
  TaskTimeReportAdded = 'TaskTimeReportAdded',
  TaskDescriptionChanged = 'TaskDescriptionChanged'
}
